
import React, {  } from "react";
import { Card } from "../../../components/Card";
import { Loading } from "../../../components/Loading";
import { PlaceHolderNotExists } from "../../../components/PlaceholderNotExists";
import { useNotificationsTable } from "./useNotificationsTable";
import { TableModifiedTable } from "components/TableModified/TableModifiedTable";
import { TableModifiedPagination } from "components/TableModified/TableModifiedPagination";


const tableHeadNotification = ["Data de envio", "Assunto", "Canal", "Email / Telefone", ""];

export const Notifications: React.FC = () => {
  const {
    loading,
    error,
    notifications,
    notificationsCount,
    pageNumber,
    requestsPerPage,
    handlePageSelected,
    handleRowsPerPageChange,
  } = useNotificationsTable();

  if (loading) {
    return (
      <Card title="Detalhes">
        <Loading />
      </Card>
    )
  }

  if (!loading && notifications.length) {
    return (
      <Card title="Detalhes">
        <TableModifiedTable
          headerColumns={tableHeadNotification}
          rows={notifications}
        />
        <TableModifiedPagination
          totalItemsCount={notificationsCount}
          pageNumber={pageNumber}
          rowsPerPage={requestsPerPage}
          onPageSelected={handlePageSelected}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </Card>
    )
  }

  return (
    <Card title="Detalhes">
      <PlaceHolderNotExists title="Usuário não possui notificações" />
    </Card>
  )
}